/** SMS/OTP section helper line only when `twoFactorAuth` is on; otherwise callers show title only. Pure function (not a hook): no React state or lifecycle. */
export function getPhoneSectionDescription(input: {
  hasVisitedCodeStep: boolean
  isOnCodeStep: boolean
  isPhoneStepComplete: boolean
  requiresSmsOtp: boolean
}): string | null {
  const { requiresSmsOtp, isPhoneStepComplete, isOnCodeStep, hasVisitedCodeStep } = input
  if (!requiresSmsOtp) return null
  if (isPhoneStepComplete) {
    return hasVisitedCodeStep ? 'Phone number is successfully verified.' : null
  }
  if (isOnCodeStep) return 'We have sent a 6-digit authorization code to your number'
  return 'We use this number to send a verification code for checkout'
}
